export default __webpack_public_path__ + "static/media/thankyou.fe599ff5.svg";